var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSpinner)?_c('div',{staticClass:"jumbotron"},[_c('p',{staticClass:"text-center"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'spinner'],"size":"2x","spin":""}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }